import styled from '@emotion/styled';
import { IconButton } from '@mui/material';

const GnbIconButton = styled(IconButton)(({ theme }) => ({
  color: '#DCE1E8',
  width: 48,
  height: 48,
  borderRadius: 0,
  svg: {
    width: 20,
    height: 20,
  },
  '&:hover': {
    backgroundColor: theme.color['surface/global/transparent/strong/hover'],
  },
  '&:active': {
    backgroundColor: theme.color['surface/global/transparent/strong/press'],
  },
  ...theme.mixins.focusRing('inside', { inverse: true }),
}));

export default GnbIconButton;
